<template>
    <div style="position: relative">

        <loading-overlay :active="pageLoading" :is-full-page="true" :lock-scroll="true" loader="dots" color="#0168b7"
                background-color="#ffffff" opacity="1" />

        <v-app-bar density="compact">
            <v-tabs v-model="activeFundTab" bg-color="#0168b7" slider-color="#fff" color="#fff" show-arrows grow center-active>
                <v-tab :value="7" :ripple="false">お知らせ</v-tab>
                <v-tab :value="1" :ripple="false">募集状況</v-tab>
                <v-tab v-if="isInvested" :value="9" :ripple="false">出資者限定</v-tab>
                <v-tab :value="2" :ripple="false">プロフィール</v-tab>
                <v-tab :value="3" :ripple="false">シミュレーション</v-tab>
                <v-tab :value="4" :ripple="false">事業計画</v-tab>
                <v-tab :value="5" :ripple="false" v-if="fund.benefitsHtml">特典</v-tab>
                <v-tab :value="6" :ripple="false">リスク</v-tab>
            </v-tabs>
        </v-app-bar>

<!-- <v-window v-model="activeFundTab" :touch="{left: null, right: null}"> -->
        <v-window v-model="activeFundTab">
            <v-window-item :value="7">
                <v-sheet>
                    <v-container>
                        <h2>お知らせ</h2>
                        <div v-if="isFundNewsEmpty" class="text-center">
                            お知らせはありません
                        </div>
                        <div v-else class="news-list">
                            <div v-for="(article, $index) in fundNews" :key="$index" class="news-list--item">

                                <article-tile
                                    :thumbnail-uri="getFirstImageSrc(article.article_txt)"
                                    :content-title="article.article_title"
                                    :content-author="fund.fundName"
                                    :content-lead="article.article_txt"
                                    :timestamp="dateFormat(article.posting_datetime)"
                                    :content-uri="`/api/fund/news/${fundId}/${article.article_id}`"
                                    :show-sns-share="`true`"
                                />
                                
                            </div>
                            <InfiniteLoading @infinite="infiniteFundNewsHandler">
                                <template #complete>
                                    <span> </span>
                                </template>
                            </InfiniteLoading>
                        </div>
                    </v-container>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="1">
                <v-sheet>
                    <v-container>

                        <div class="fund-tile">

                            <h2 class="fund-tile__subtitle mb-2">
                                <div class="mb-1">
                                    <v-chip variant="outlined" color="primary" class="fund-tile__status" :input-value="true" label>{{ fund.statusName }}</v-chip>
                                </div>
                                <div>
                                    {{ fund.fundName }}
                                </div>
                            </h2>

                            <div class="fund-tile__thumbnail fund-tile__thumbnail--default rounded-xl">
                                <div class="fund-tile__thumbnail__cover" :style="fund_main_bg"></div>
                            </div>

                            <div class="fund-tile__title">{{ decodeHtmlEscape(fund.description) }}</div>

                            <div class="fund-tile__title d-flex align-center my-5" @click="onClickedPartner">
                                <div class="partner-icon partner-icon--default">
                                    <div class="partner-icon__cover" :style="partner_main_bg">{{ partner_icon_name }}</div>
                                </div>
                                <div>{{ partner.partnerName }}</div>
                            </div>

                            <div class="price d-flex align-center justify-space-between my-5">
                                <div>一口金額</div>
                                <div class="d-flex align-baseline" style="gap: 4px;">
                                    <div style="font-size: 1.6em;">{{ unitPrice }}</div>
                                    <div>円</div>
                                </div>
                            </div>

                            <div v-if="fund.showPublishExpDoc" class="text-primary text-center my-4" style="font-size: 1rem; font-weight: 600;">
                                <a class="decoration-none" :href="fund.publishTkExpDocUrl" target="_blank"><v-icon size="small" class="mr-1" icon="mdi-text-box-multiple-outline" /><span>重要情報（匿名組合契約説明書）</span></a>
                            </div>
                            
                            <div class="mt-5" style="display: flex; gap: 8px; flex-flow: column;">
                                <v-btn block v-if="isRecruiting && !isInvested" id="id-go-order" color="primary" variant="elevated" class="rounded-pill" :ripple="false" @click="onClickedOrder">ファンドを申し込む</v-btn>
                            </div>

                            <div class="mt-4" style="display: flex; align-items: center; justify-content: end; gap: 12px;">
                                <SnsShare :url="shareUrl" :align="`right`" />
                                <v-btn :loading="isLoading"
                                        id="id-watch-icon"
                                        :class="{'checked': isWatched}"
                                        background-color="white"
                                        :ripple="false"
                                        variant="text"
                                        icon="mdi-heart"
                                        density="compact"
                                        @click="onClickedWatch"
                                        style="font-size: 24px; margin-bottom: 12px;"
                                >
                                </v-btn>
                            </div>

                            <h2>募集状況</h2>

                            <div class="price d-flex align-center justify-space-between my-3">
                                <div>募集総額</div>
                                <div class="d-flex align-baseline" style="gap: 4px;">
                                    <div style="font-size: 1.6em;">{{ totalPrice }}</div>
                                    <div>円</div>
                                </div>
                            </div>

                            <div class="price d-flex align-center justify-space-between my-3">
                                <div>現在</div>
                                <div class="d-flex align-baseline gradation" style="gap: 4px; font-weight: 600;">
                                    <div style="font-size: 1.6em;">{{ currentPrice }}</div>
                                    <div>円</div>
                                </div>
                            </div>

                            <div class="price d-flex align-center justify-space-between my-3">
                                <div>参加者</div>
                                <div class="d-flex align-baseline gradation" style="gap: 4px; font-weight: 600;">
                                    <div style="font-size: 1.6em;">{{ supporter }}</div>
                                    <div>人</div>
                                </div>
                            </div>

                            <div v-if="isRecruiting" class="price d-flex align-center justify-space-between my-3">
                                <div>残日数</div>
                                <div class="d-flex align-baseline gradation" style="gap: 4px; font-weight: 600;">
                                    <div style="font-size: 1.6em;">{{ calcRemainingDays(fund.recruitEnd) }}</div>
                                    <div>日</div>
                                </div>
                            </div>

                            <div v-if="fund.hasBenefits" class="text-primary text-center my-4" style="font-size: 1rem; font-weight: 600;" @click="onClickedBenefit">
                                <span>このファンドには特典があります</span><v-icon size="small" class="ml-1" icon="mdi-comment-arrow-right-outline" />
                            </div>

                            <div v-if="!isCommentEmpty">
                                <h2 class="mt-8">出資者の声</h2>
                                <div class="fund-tile__comment comment-list">
                                    <template v-for="(comment, $index) in comments" :key="$index">
                                        <UserComment
                                            :user-address="comment.address"
                                            :user-comment="comment.user_comment"
                                            :comment-date="dateFormat(comment.buy_date)"
                                        />
                                    </template>
                                    <InfiniteLoading @infinite="infiniteCommentsHandler">
                                        <template #complete>
                                            <span> </span>
                                        </template>
                                    </InfiniteLoading>
                                </div>
                            </div>

                            <h2 class="mt-8">募集条件</h2>

                            <fundHtml class="my-5" :htmlDoc="fund.boshuHtml" />

                            <div class="text-primary text-center my-4" style="font-size: 1rem; font-weight: 600;" @click="onClickedSimulation">
                                <span>シミュレーションを見る</span><v-icon size="small" class="ml-1" icon="mdi-comment-arrow-right-outline" />
                            </div>
                            <div class="text-primary text-center my-4" style="font-size: 1rem; font-weight: 600;" @click="onClickedPlan">
                                <span>事業計画を見る</span><v-icon size="small" class="ml-1" icon="mdi-comment-arrow-right-outline" />
                            </div>

                            <div class="mt-5" v-if="isRecruiting && !isInvested" style="display: flex; gap: 8px; flex-flow: column;">
                                <v-btn block id="id-go-order" color="primary" variant="elevated" class="rounded-pill" :ripple="false" @click="onClickedOrder">ファンドを申し込む</v-btn>
                            </div>

                        </div>
                    </v-container>
                </v-sheet>
            </v-window-item>

            <v-window-item  v-if="isInvested" :value="9">
                <v-sheet>
                    <v-container>

                        
                        <h2>ファンド情報</h2>

                        <div>

                            <ul class="block-layout-grid gap--large prop-li--flow-col mb-2">
                                <li>
                                    <span class="prop-li__name">営業者名</span>
                                    <span class="prop-li__value text-left">{{ investor.digest.operatorName }}</span>
                                </li>
                            </ul>

                            <ul class="block-layout-grid gap--large prop-li--flex-row">
                                <li>
                                    <span class="prop-li__name">ファンド総額</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.digest.total_price) }} 円</span>
                                </li>
                                <li>
                                    <span class="prop-li__name">募集口数</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.digest.total_suryo) }} 口</span>
                                </li>
                                <li>
                                    <span class="prop-li__name">会計期間</span>
                                    <span class="prop-li__value">{{ dateFormat(investor.digest.financial_start) }} ~ {{ dateFormat(investor.digest.financial_end) }}</span>
                                </li>
                            </ul>

                        </div>

                        <h2 class="mt-8">お申込情報</h2>

                        <div>
                            <ul class="block-layout-grid gap--large prop-li--flex-row">
                                <li>
                                    <span class="prop-li__name">出資金額</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.digest.investmentPrice) }} 円</span>
                                </li>
                                <li>
                                    <span class="prop-li__name">出資口数</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.digest.investmentUnit) }} 口</span>
                                </li>
                            </ul>
                        </div>

                        <h2 class="mt-8">分配実績</h2>

                        <div>
                            <ul class="block-layout-grid gap--large  prop-li--flex-row mb-4">
                                <li>
                                    <span class="prop-li__name">分配金額 ※3</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.digest.memberDeposit, 0) }} 円</span>
                                </li>
                                <li>
                                    <span class="prop-li__name">償還率 ※3</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.digest.refundRate, 0) }} %</span>
                                </li>
                            </ul>

                            <ul class="text-caption" style="padding-left: 2.0em;">
                                <li style="text-indent: -2.0em;">
                                    ※3「ファンド情報」の分配金額と償還率は、現在までに分配金としてお支払した金額を元に算出しています。
                                    源泉税の徴収がある場合は、源泉徴収後の数値が表示されます。
                                </li>
                            </ul>
                        </div>

                        <h2 class="mt-8">分配明細書</h2>

                        <div v-if="investor.dividend.docs.length > 1" class="block-layout-grid gap--large">
                            <div v-for="(doc, $index) in investor.dividend.docs" :key="$index" class="dividend-docs-list--item">
                                <v-btn :href="`/fund/doc/dividend?doc_id=${doc.deposit_doc_id}`" target="_blank" color="primary" variant="outlined" :ripple="false" style="background-color: #ffffff;" size="x-large" block>
                                    <div>
                                        <v-icon class="mr-1" start icon="mdi-file-document-outline" />
                                        <span>{{ doc.is_refunded == 1 ? '償還明細書' : `第 ${doc.term} 回 分配明細書` }}</span>
                                        <div class="text-center text-caption">{{ dateFormat(doc.published_at) }} 公開</div>
                                    </div>
                                </v-btn>
                            </div>
                        </div>
                        <div v-if="investor.dividend.html" class="my-5">
                            <fundHtml :htmlDoc="investor.dividend.html" />
                        </div>

                        <h2 class="mt-8">運用状況</h2>

                        <div>
                            <ul class="block-layout-grid gap--large  prop-li--flex-row mb-4">
                                <li style="align-items: start;">
                                    <span class="prop-li__name">最新売上</span>
                                    <div class="prop-li__value">
                                        <div>{{ numberFormat(investor.report.lastUriage) }} 円</div>
                                        <div class="text-caption">{{ dateFormat(investor.report.lastUriageDate) }} 更新</div>
                                    </div>
                                </li>
                                <li>
                                    <span class="prop-li__name">累計売上</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.report.totalUriage, 0) }} 円</span>
                                </li>
                                <li v-if="investor.report.recoupUriage">
                                    <span class="prop-li__name">予測損益分岐売上</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.report.recoupUriage) }} 円</span>
                                </li>
                                <li>
                                    <span class="prop-li__name">現在の一口価格 ※2</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.report.currentPrice, 0) }} 円</span>
                                </li>
                                <li>
                                    <span class="prop-li__name">現在の償還率 ※2</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.report.currentRate, 0) }} %</span>
                                </li>
                                <li>
                                    <span class="prop-li__name">会計期間経過率</span>
                                    <span class="prop-li__value">{{ numberFormat(investor.report.currentTimeSlice) }} %</span>
                                </li>
                            </ul>

                            <ul class="text-caption" style="padding-left: 2.0em;">
                                <li style="text-indent: -2.0em;">
                                    ※2「最新情報」の売上金額は監査前のため変動する可能性があります。
                                    現在の一口価格と償還率は、最新の売上金額を元に算出した見込みの数値です。速報値としてご確認ください。
                                    最終売上金額については監査後の分配明細書にてご報告いたします。
                                </li>
                            </ul>
                        </div>

                        <h2 class="mt-8">出資者限定ニュース</h2>

                        <div v-if="isInvestorNewsEmpty" class="text-center">
                            お知らせはありません
                        </div>
                        <div v-else class="news-list slide-cintainer">
                            <div v-for="(article, $index) in investorNews" :key="$index" class="news-list--item">
                                <article-tile
                                    :thumbnail-uri="getFirstImageSrc(article.article_txt)"
                                    :content-title="article.article_title"
                                    :content-author="fund.fundName"
                                    :content-lead="article.article_txt"
                                    :timestamp="dateFormat(article.posting_datetime)"
                                    :content-uri="`/api/fund/investor/news/${fundId}/${article.article_id}`"
                                />
                            </div>
                            <InfiniteLoading @infinite="infiniteInvestorNewsHandler">
                                <template #complete>
                                    <span> </span>
                                </template>
                            </InfiniteLoading>
                        </div>

                        <div v-if="investor.socialReturn != undefined">
                            <h2 class="mt-8">社会的リターン</h2>
                            <div class="mb-6" v-for="(sreturn, key) in investor.socialReturn" :key="key">
                                <h3 class="mb-3">{{ sreturn.metric.metric_description }}</h3>
                                <table class="mb-3">
                                    <tbody>
                                        <tr>
                                            <th width="120">事業が目指す成果</th>
                                            <td>{{ sreturn.metric.result_description }}</td>
                                        </tr>
                                        <tr>
                                            <th>指標</th>
                                            <td>{{ sreturn.metric.metric_description }}</td>
                                        </tr>
                                        <tr v-if="sreturn.metric.target > 0">
                                            <th>目標値</th>
                                            <td>{{ sreturn.metric.target }}{{ sreturn.metric.index_type }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style="max-height: 200px; overflow-y: scroll;">
                                    {{ sreturn.metric.totalData }}
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th class="text-center">
                                                    <span v-if="sreturn.metric.graph_type == 'pie'">概要</span>
                                                    <span v-else>年度</span>
                                                </th>
                                                <th class="text-center">実績値</th>
                                            </tr>
                                            <tr v-for="(result, year) in sreturn.data" :key="year">
                                                <td class="text-center">{{ year }}</td>
                                                <td class="text-center">
                                                    {{ result }}{{ sreturn.metric.index_type }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <h2 class="mt-8">契約書面</h2>

                        <div class="block-layout-grid gap--large">
                            <v-btn :href="fund.investorTkExpDocUrl" target="_blank" color="primary" variant="outlined" :ripple="false" style="background-color: #ffffff;" size="x-large" block>
                                <v-icon size="small" class="mr-1" icon="mdi-text-box-multiple-outline" />
                                <span>匿名組合契約説明書</span>
                            </v-btn>
                            <v-btn :href="fund.investorTkDocUrl" target="_blank" color="primary" variant="outlined" :ripple="false" style="background-color: #ffffff;" size="x-large" block>
                                <v-icon size="small" class="mr-1" icon="mdi-text-box-multiple-outline" />
                                <span>匿名組合契約書</span>
                            </v-btn>
                        </div>

                    </v-container>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="2">
                <v-sheet>
                    <v-container>
                        <h2>{{ partner.partnerName }}のプロフィール</h2>
                        <fundHtml class="my-5" :htmlDoc="partner.profileHtml" />
                        <h2 class="mt-8">事業内容</h2>
                        <fundHtml class="my-5" :htmlDoc="fund.businessHtml" />
                    </v-container>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="3">
                <v-sheet>
                    <v-container>
                        <h2>分配シミュレーション</h2>
                        <fundHtml class="my-5" :htmlDoc="fund.distributionHtml" />
                    </v-container>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="4">
                <v-sheet>
                    <v-container>
                        <h2>事業計画</h2>
                        <fundHtml class="my-5" :htmlDoc="fund.businessplanHtml" />
                    </v-container>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="5" v-if="fund.benefitsHtml">
                <v-sheet>
                    <v-container>
                        <h2>特典</h2>
                        <fundHtml class="my-5" :htmlDoc="fund.benefitsHtml" />
                    </v-container>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="6">
                <v-sheet>
                    <v-container>
                        <h2>リスク</h2>
                        <fundHtml class="my-5" :htmlDoc="fund.riskHtml" />
                    </v-container>
                </v-sheet>
            </v-window-item>

        </v-window>
            
        <div v-if="activeFundTab > 1" class="cta-container text-center px-5" style="position: fixed; bottom: 88px; width: 100%; display: flex; flex-flow: column; gap: 8px;">
            <v-btn v-if="isRecruiting && !isInvested" id="id-go-order" color="primary" variant="elevated" class="rounded-pill" :ripple="false" @click="onClickedOrder" block>ファンドを申し込む</v-btn>
        </div>
        
    </div>
</template>

<style scoped>

a.decoration-none{
    color: inherit;
    text-decoration: none;
}

a.decoration-none:visited{
    color: inherit;
}

a.decoration-none:hover{
    color: inherit;
}

.v-container {
    margin-bottom: 30px;
}

.prop-li--flex-row li{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: wrap;
    gap: 8px;
}

.prop-li--flow-col li{
    display: flex;
    flex-flow: column;
    gap: 8px;
}
.prop-li__name{
    color: #666;
}
.prop-li__value{
    font-size: 1.1em;
    text-align: right;
}
.block-layout-grid {
    display: flex;
    flex-flow: column;
}
.block-layout-grid li {
    padding: 8px;
    border-bottom: 1px solid #aaa;
}
.gap--small{
    gap: 4px;
}

.gap--large{
    gap: 8px;
}

.gap--large{
    gap: 8px;
}

#id-watch-icon{
    color: #cccccc;
}
#id-watch-icon.checked{
    color: #ff0000;
}
.cta-container .v-btn{
    opacity: 0.8;
}
.cta-container .v-btn:hover{
    opacity: 1;
}

.v-window-item {
    min-height: calc(100vh - 180px);
}
.comment-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
    max-height: 280px;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.comment-list::-webkit-scrollbar{
    display: none;
}

.news-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    max-width: 800px;
}

.news-list--item{
    width: 100%;
}
.slide-cintainer{
    height: 300px;
    overflow-y: auto;
}

.fund-tile {}

.fund-tile__status {
}

.fund-tile__thumbnail {
    margin-top: 8px;
    width: 100%;
    overflow: hidden;
    aspect-ratio: 16 / 9;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.fund-tile__thumbnail--default {
    background-color: #aaa;
    background-image: url('../assets/images/now_loading_fund_thumb.jpg');
}

.fund-tile__thumbnail__cover {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.fund-tile__subtitle {

}

.fund-tile__title {
    margin-top: 4px;
    gap: 8px;
}

.fund-tile__comment {
}

.partner-icon {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 60px;
    height: 60px;
    border-radius: 50%;
}

.partner-icon--default {
    background-color: #d3e4ff;
}

.partner-icon__cover {
    width: inherit;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.4rem;
    color: #fff;
}

.v-tab.v-tab {
    opacity: 0.4;
}
.v-tab.v-tab.v-tab--selected {
    opacity: 1;
}
</style>

<script>

import axios from "axios"
import Helper from "../assets/js/helper"
import InfiniteLoading from "v3-infinite-loading"
import LoadingOverlay from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "v3-infinite-loading/lib/style.css"
import CommentImage from "../assets/images/supporter.png"
import ArticleTile from "../components/ArticleTile"
import fundHtml from "../components/fundHtml"
import SnsShare from "../components/SnsShare"
import UserComment from "../components/UserComment"

const fundContentApi = '/api/fund/detail'
const fundNewsListApi = '/api/fund/news/list'
const fundInvestorNewsListApi = '/api/invest/news/list'
const commentListApi = '/api/fund/comment/list'
const watchListApi = '/api/watch/item/save'

export default {
    components: {
        InfiniteLoading,
        LoadingOverlay,
        ArticleTile,
        fundHtml,
        SnsShare,
        UserComment
    },
    data: () => ({
        'pageLoading': true,
        'isLoading': false,
        'isRecruiting': false,
        'isWatched': false,
        'isInvested': false,
        'isCommentEmpty': false,
        'isFundNewsEmpty': false,
        'isInvestorNewsEmpty': false,
        'fundId': '',
        'fundNewsPage': 0,
        'investorNewsPage': 0,
        'comment_page': 0,
        'fund': {
            'statusName': '',
            'fundName': '',
            'description': '',
            'businessHtml': '',
            'benefitsHtml': '',
            'hasBenefits': false,
            'riskHtml': '',
            'distributionHtml': '',
            'businessplanHtml': '',
            'boshuHtml': '',
            'recruitEnd': '',
            'showPublishExpDoc': false,
            'publishTkExpDocUrl': '',
            'investorTkExpDocUrl': '',
            'investorTkDocUrl': '',
        },
        'investor': {
        },
        'partner': {
            'partnerName': '',
            'companyName': '',
            'companyAddress': '',
            'profileHtml': '',
            'presidentName': '',
            'business': '',
            'settlingDay': '',
        },
        'score': {
            'currentPrice': '-',
            'fee': '-',
            'supporter': '-',
            'totalPrice': '-',
            'investmentPrice': '-',
            'donationPrice': '-',
            'purchasePrice': '-',
            'unitPrice': '-',
        },
        fundNews: [],
        investorNews: [],
        comments: [],
        fund_main_bg: {},
        partner_main_bg: {},
        comment_icon_bg: {
            backgroundImage: `url('${CommentImage}')`,
        },
        shareUrl: window.location.href,
        partner_icon_name: '',
    }),
    watch: {
        'fund.fundName': function(to) {
            if(to){
                this.$store.dispatch('setActivePageTitle', to)
                console.log('fund title setted ', to)
            }
        },
    },
    computed: {
        activeFundTab: {
            get() {
                return this.$store.getters.activeFundTab
            },
            set(value) {
                this.$store.dispatch("setActiveFundtab", value)
            }
        },
        investmentPrice: function () {
            return Helper.addComma(this.score.investmentPrice)
        },
        donationPrice: function () {
            return Helper.addComma(this.score.donationPrice)
        },
        purchasePrice: function () {
            return Helper.addComma(this.score.purchasePrice)
        },
        currentPrice: function () {
            return Helper.addComma(this.score.currentPrice)
        },
        unitPrice: function () {
            return Helper.addComma(this.score.unitPrice)
        },
        totalPrice: function () {
            return Helper.addComma(this.score.totalPrice)
        },
        fee: function () {
            return Helper.addComma(this.score.fee)
        },
        supporter: function () {
            return Helper.addComma(this.score.supporter)
        },
        flushMessage: {
            set(value) {
                this.$store.dispatch("setFlushMessage", value);
            }
        }
    },
    created: async function () {

        this.fundId = this.$route.query.fund_id

        try {

            const response = await axios.get(fundContentApi, {
                params: {
                    fund_id: this.fundId
                }
            })

            console.log(response);

            // ファンド系
            this.fund_main_bg = { backgroundImage: `url('/data/fund/${this.fundId}/top.jpg')` };
            this.fund.fundName = response.data.fund.fundName
            this.fund.statusName = response.data.fund.statusName
            this.fund.description = response.data.fund.description
            this.fund.businessHtml = response.data.fund.businessHtml
            this.fund.benefitsHtml = response.data.fund.benefitsHtml
            this.fund.hasBenefits = response.data.fund.hasBenefits
            this.fund.riskHtml = response.data.fund.riskHtml
            this.fund.distributionHtml = response.data.fund.distributionHtml
            this.fund.businessplanHtml = response.data.fund.businessplanHtml
            this.fund.boshuHtml = response.data.fund.boshuHtml
            this.fund.recruitEnd = response.data.fund.recruitEnd
            this.fund.showPublishExpDoc = response.data.fund.showPublishExpDoc
            this.fund.publishTkExpDocUrl = response.data.fund.publishTkExpDocUrl
            this.fund.investorTkExpDocUrl = response.data.fund.investorTkExpDocUrl
            this.fund.investorTkDocUrl = response.data.fund.investorTkDocUrl

            // 数字系
            this.score.currentPrice = response.data.score.currentPrice
            this.score.fee = response.data.score.fee
            this.score.supporter = response.data.score.supporter
            this.score.totalPrice = response.data.score.totalPrice
            this.score.investmentPrice = response.data.score.investmentPrice
            this.score.donationPrice = response.data.score.donationPrice
            this.score.purchasePrice = response.data.score.purchasePrice
            this.score.unitPrice = response.data.score.unitPrice

            // 出資者限定
            this.investor = response.data.investor

            // 事業者系
            if(response.data.partner.partnerIconName != ''){
                this.partner_icon_name = response.data.partner.partnerIconName
            }else{
                this.partner_main_bg = { backgroundImage: `url('/data/partner/${response.data.partner.partnerId}/owner.jpg')` }
            }
            this.partner.partnerName = response.data.partner.partnerName
            this.partner.companyName = response.data.partner.companyName
            this.partner.profileHtml = response.data.partner.profileHtml

            this.isWatched = response.data.status.isWatched
            this.isInvested = response.data.status.isInvested
            this.isRecruiting = response.data.status.isRecruiting

            this.$nextTick(() => {
                this.pageLoading = false
            })
            
            // スワイプイベントのターゲットがテーブル要素の場合はスライド優先のためキャンセルする
            const touchCancelBehavior = e => {
                if (e.target.tagName === 'TH' || e.target.tagName === 'TD') {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }

            let wList = document.querySelectorAll('.v-window, .v-window__container, .v-window-item')
            wList.forEach( target => {
                target.addEventListener('touchstart', touchCancelBehavior)
                target.addEventListener('touchmove', touchCancelBehavior)
                target.addEventListener('touchend', touchCancelBehavior)
            })

            //ページアクセスの情報を保存
            const accessParams = new URLSearchParams();
            accessParams.append('page_id', this.fundId);
            accessParams.append('page_type', 'fund');
            await axios.post('/api/spa/page/access', accessParams).catch(() => {
                return;
            });

        } catch (error) {
            console.log(error)
            this.$router.push('/progressive');
            return;
        }
    },
    mounted: function() {
    },
    methods: {
        dateFormat(date){
            return date == null ? '' : Helper.formatDate(date)
        },
        numberFormat(number, defaultStr){
            return number == null ? defaultStr ?? '-' : Helper.addComma(number)
        },
        getFirstImageSrc: htmlString => {
            return Helper.getFirstImageSrc(htmlString);
        },
        onClickedPartner(){
            this.$store.dispatch('setActiveFundtab', 2)
        },
        onClickedBenefit(){
            this.$store.dispatch('setActiveFundtab', 5)
        },
        onClickedOrder(){
            window.open(`/fund/order/form?f_id=${this.fundId}&utm_source=webapp&utm_medium=referral&utm_campaign=order_form`)
        },
        onClickedSimulation(){
            this.$store.dispatch('setActiveFundtab', 3)
        },
        onClickedPlan(){
            this.$store.dispatch('setActiveFundtab', 4)
        },
        onClickedWatch(){
            (async () => {
                try{
                    this.isLoading = true
                    var params = new URLSearchParams();
                    params.append('fund_id', this.fundId);
                    params.append('mode', this.isWatched ? 'del' : 'add');
                    const response = await axios.post(watchListApi, params)
                    console.log(response)
                    this.isWatched = !this.isWatched

                    this.flushMessage = this.isWatched ? 'ウォッチリストに登録しました' : 'ウォッチリストを解除しました'

                }catch(error){
                    console.log(error)
                    alert('ウォッチリストの登録に失敗しました。画面右上のリロードボタンからページを更新後、再度お試しください。')
                }finally{
                    this.isLoading = false
                }
            })()
        },
        async infiniteCommentsHandler($state) {

            const res = await axios.get(commentListApi, {
                params: {
                    fund_id: this.fundId,
                    limit: 10,
                    pg: this.comment_page
                }
            }).catch(() => {
                return;
            });
            
            if (res.data.length > 0) {
                this.comment_page++;
                this.comments.push(...res.data);
                $state.loaded();
            } else {
                $state.complete();
                this.isCommentEmpty = this.comments.length == 0
            }
        },
        async infiniteFundNewsHandler($state) {

            const res = await axios.get(fundNewsListApi, {
                params: {
                    fund_id: this.fundId,
                    limit: 10,
                    pg: this.fundNewsPage
                }
            }).catch(() => {
                return;
            });

            if (res.data.length > 0) {
                this.fundNewsPage++;
                this.fundNews.push(...res.data);
                $state.loaded();
            } else {
                $state.complete();
                this.isFundNewsEmpty = this.fundNews.length == 0
            }
        },
        async infiniteInvestorNewsHandler($state) {

            const res = await axios.get(fundInvestorNewsListApi, {
                params: {
                    fund_id: this.fundId,
                    limit: 10,
                    pg: this.investorNewsPage
                }
            }).catch(() => {
                return;
            });

            if (res.data.length > 0) {
                this.investorNewsPage++;
                this.investorNews.push(...res.data);
                $state.loaded();
            } else {
                $state.complete();
                this.isInvestorNewsEmpty = this.investorNews.length == 0
            }
        },
        decodeHtmlEscape(string){
            return Helper.decodeHtmlEscape(string)
        },
        calcRemainingDays(datetime){
            return Helper.calcRemainingDays(datetime)
        }
    }
}
</script>